import { apiService } from '@/services/APIService';

export default {
  get(params) {
    return apiService.get('/actions', params);
  },
  create(params) {
    return apiService.post('/actions', params);
  },
  delete(id) {
    return apiService.delete(`/actions/${id}`);
  },
};
